<style scoped>

  #animals-segment {
    min-height: 340px;
  }

</style>

<template>
  
  <div>

    <div class="ui large breadcrumb">
      <a class="clickable" @click="$historyBack()">
        <i class="reply icon m-r-5"></i> Voltar
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>Animais do Tutor</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-show="!loading" class="animated fadeIn">  

      <div class="ui segment">
        <h4 class="ui dividing header">Dados Cadastrais</h4>
        <div class="ui form">          
          <div class="fields">
            <div class="five wide field">
              <label class="form-label">Nome</label>
              {{ owner.name }}
            </div>                                          
            <div class="four wide field">
              <label class="form-label">E-mail</label>
              {{ owner.email }}
            </div>                                                     
            <div class="three wide field">
              <label class="form-label">Celular</label>
              {{ owner.mobile }}
            </div>            
            <div class="three wide field">
              <label class="form-label">Telefone</label>
              {{ owner.phone }}
            </div>                        
          </div>
        </div>
      </div> 

      <div id="animals-segment" class="ui segment" :class="{ loading: loadingAnimals }">
        
        <h4 class="ui dividing header">Animais</h4>

        <button class="ui mini basic button" @click="$refs.animalFormModal.create({ ownerId: owner.id })">
          <i class="plus blue icon"></i> Adicionar
        </button>

        <p v-if="animals.length == 0 && !loadingAnimals" class="grey text m-t-20">
          <i class="info circle icon"></i> Nenhum animal adicionado
        </p> 

        <animal-card-list class="m-t-10" ref="animalCardList" :fetcher="loadAnimals"
          @onUpdateOwner="loadOwner()" />

      </div>  

    </div>  

    <animal-form-modal ref="animalFormModal" @onSave="$refs.animalCardList.fetchData()" />

  </div>

</template>  

<script>

  import onlySimavet from "@/mixins/only-simavet"  
  import OwnerService from "@/services/owner-service"
  import AnimalFormModal from "@/pages/entries/animals/form-modal"
  import AnimalCardList from "@/pages/entries/animals/card-list"

  export default {
    
    name: "ShowOwner",

    mixins: [onlySimavet],

    data() {
      return {
        service: new OwnerService(),
        owner: {},
        animals: [],
        loading: true,
        loadingAnimals: true,
      }
    },

    components: {
      AnimalFormModal,
      AnimalCardList,
    },

    mounted() {
      this.loadOwner()
    },

    methods: {

      goBack() {
        this.$router.push("/entries/owners")
      },

      async loadOwner() {

        this.loading = true

        try {

          this.owner = await this.service.findById(this.$route.params.id)
          
          this.$refs.animalCardList.fetchData()

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false
        }
      },

      async loadAnimals() {

        this.loadingAnimals = true

        try {

          this.animals = await this.service.findAnimals(this.owner.id)        

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loadingAnimals = false
        }

        return this.animals.slice()
      },
    },
  }

</script>  